import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
import { getLocalOfferNames, getLocalRejectOfferResult } from 'src/components/shared/helper/ViewKeyToServerKeyMapper'
import { objectMapper, serverJsonToViewJson } from 'src/components/shared/helper/ServerOjectToViewObject'

const state = {
  [NameSpace.STATE_OFFER_NAMES]: {
    value: [],
    error: null
  },
  [NameSpace.STATE_SELECTED_OFFER_NAME]: {
    offerData: null
  },
  [NameSpace.STATE_REJECT_OFFER_RESULT]: {
    rejectOfferResult: null,
    error: null
  }
}

const getters = {
  [NameSpace.GET_OFFER_NAMES]: state => {
    return state[NameSpace.STATE_OFFER_NAMES]
  },
  [NameSpace.GET_SELECTED_OFFER_NAME]: state => {
    return state[NameSpace.STATE_SELECTED_OFFER_NAME]
  },
  [NameSpace.GET_REJECT_OFFER_RESULT]: state => {
    return state[NameSpace.STATE_REJECT_OFFER_RESULT]
  }
}

const mutations = {
  [NameSpace.MUTATE_OFFER_NAMES]: (state, payload) => {
    state[NameSpace.STATE_OFFER_NAMES] = payload
  },
  [NameSpace.MUTATE_SELECTED_OFFER_NAME]: (state, payload) => {
    state[NameSpace.STATE_SELECTED_OFFER_NAME] = payload
  },
  [NameSpace.MUTATE_REJECT_OFFER_RESULT]: (state, payload) => {
    state[NameSpace.STATE_REJECT_OFFER_RESULT] = payload
  }
}

const actions = {
  [NameSpace.ACTION_FETCH_OFFER_NAMES]: ({ commit }, payload) => {
    ParseService.getOfferNames(payload)
      .then(offerNames => {
        let data = objectMapper(offerNames, getLocalOfferNames)
        if (data) {
          commit(NameSpace.MUTATE_OFFER_NAMES, {value: data, error: null})
        } else {
          commit(NameSpace.MUTATE_OFFER_NAMES, {value: [], error: null})
        }
      })
      .catch(error => {
        console.log(error)
        commit(NameSpace.MUTATE_OFFER_NAMES, {value: [], error: error})
      })
  },
  [NameSpace.ACTION_SELECT_OFFER_NAME]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_OFFER_NAME, payload)
  },
  [NameSpace.ACTION_REJECT_OFFER]: ({ commit }, payload) => {
    ParseService.rejectOffer(payload)
      .then(rejectOffer => {
        let data = serverJsonToViewJson(rejectOffer, getLocalRejectOfferResult)
        if (data) {
          commit(NameSpace.MUTATE_REJECT_OFFER_RESULT, { rejectOfferResult: data, error: null })
        } else {
          commit(NameSpace.MUTATE_REJECT_OFFER_RESULT, { rejectOfferResult: null, error: null })
        }
      })
      .catch(error => {
        console.log(error)
        commit(NameSpace.MUTATE_REJECT_OFFER_RESULT, { rejectOfferResult: null, error: error })
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/offerList.js